import { GetCompanySearchResponse } from '@iwoca/lapi-client/edge';
import { v4 } from 'uuid';

import { TGetStartedDataUK } from './GetStartedUK';
import { isPartnerAffiliateTag } from '../../../helpers/isPartnerAffiliateTag';
import { TPostStateRequestBody } from '../../../types';
import { TGetStartedDataDE } from '../GetStartedDE/GetStartedDE';

export const getInitialStateBody = (
  affiliateTag: string,
  values: (TGetStartedDataUK | TGetStartedDataDE) & {
    prefilledCompany?: GetCompanySearchResponse['data'][number] | null;
  },
): TPostStateRequestBody => {
  const state: TPostStateRequestBody = {
    data: {
      application: {
        people: [
          {
            emails: [
              {
                email: values.email,
                type: 'primary',
                uid: v4(),
              },
            ],
            uid: v4(),
            roles: ['applicant', 'director', 'guarantor'],
          },
        ],
      },
    },
  };

  if (isPartnerAffiliateTag(affiliateTag)) {
    state.data.impersonation = { affiliate_tag: affiliateTag };
  }

  if (values.prefilledCompany) {
    state.data.application!.company = {
      company_number: values.prefilledCompany.number,
      registered_company_name: values.prefilledCompany.name,
      trading_from_date: values.prefilledCompany.registration_date,
      type: values.prefilledCompany.company_type,
    };
  }

  return state;
};
